(() => {
  function initHero() {
    const root = document.querySelector('.slider-main_component.is-hero_bg');
    if (!root) return;
    const swiperEl = root.querySelector('.swiper.is-hero_bg');
    if (!swiperEl) return;

    // eslint-disable-next-line no-undef
    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 1000,
      autoplay: { delay: 5000, disableOnInteraction: false },
      navigation: {
        nextEl: root.querySelector('.swiper-next'),
        prevEl: root.querySelector('.swiper-prev')
      }
    });
  }

  function initProductSliders() {
    document.querySelectorAll('.slider-main_component.is-product_slider').forEach((root) => {
      const swiperEl = root.querySelector('.swiper.is-product_slider');
      if (!swiperEl) return;

      const isHome = root.hasAttribute('data-home-product-slider');
      // Home cards are 75% of the default slide width (slidesPerView / 0.75).
      const slides = isHome
        ? { base: 1.6, 480: 2.93, 768: 4.27, 992: 5.6 }
        : { base: 1.2, 480: 2.2, 768: 3.2, 992: 4.2 };

      // eslint-disable-next-line no-undef
      new Swiper(swiperEl, {
        slidesPerView: slides.base,
        spaceBetween: 16,
        loop: false,
        speed: 500,
        navigation: {
          nextEl: root.querySelector('.swiper-next') || undefined,
          prevEl: root.querySelector('.swiper-prev') || undefined
        },
        breakpoints: {
          480: { slidesPerView: slides[480], spaceBetween: 16 },
          768: { slidesPerView: slides[768], spaceBetween: 20 },
          992: { slidesPerView: slides[992], spaceBetween: 24 }
        }
      });
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function run() {
    if (typeof window.Swiper === 'undefined') return;
    initHero();
    initProductSliders();
  }

  window.KasuriInitProductSliders = initProductSliders;

  onReady(run);
})();


